type Props = {
  text?: string;
  onRetry?: () => void;
};

export default function AutoOpenOverlay({
  text = "загрузка...",
  onRetry,
}: Props) {
  return (
    <div className="tp-auto-open-overlay" role="status" aria-live="polite">
      <span className="tp-auto-open-text">{text}</span>
      {onRetry ? (
        <button type="button" className="tp-button-primary" onClick={onRetry}>
          повторить
        </button>
      ) : null}
    </div>
  );
}
